import React, { useState } from 'react';

const UserInfo = ({ user, screen }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [copied, setCopied] = useState(false);

    // Hide on game screens to prevent blocking controls
    if (!user || ['playing', 'finished', 'archivedGame', 'playerPerformance'].includes(screen)) return null;

    const initial = user.email ? user.email[0].toUpperCase() : 'G';

    const handleCopy = (e) => {
        e.stopPropagation();
        navigator.clipboard.writeText(user.email);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div
            className={`fixed bottom-3 left-3 z-[100] flex items-center bg-black/40 backdrop-blur-md border border-white/10 rounded-full shadow-lg transition-all duration-300 ease-out cursor-pointer group opacity-60 hover:opacity-100 ${isExpanded ? 'pr-4 pl-1 py-1 gap-3' : 'p-1'}`}
            onClick={() => setIsExpanded(!isExpanded)}
        >
            {/* Avatar Circle */}
            <div className="relative w-7 h-7 rounded-full bg-gradient-to-br from-amber-500 to-orange-600 flex items-center justify-center shadow-inner flex-shrink-0">
                <span className="text-[10px] font-black text-[#1e293b]">{initial}</span>

                {/* Online Ring */}
                <div className="absolute inset-0 rounded-full border-2 border-green-500/50 animate-pulse" />
                <div className="absolute bottom-0 right-0 w-2 h-2 bg-green-500 border-2 border-[#1e293b] rounded-full" />
            </div>

            {/* Expanded Details */}
            {isExpanded && (
                <div className="flex flex-col whitespace-nowrap">
                    <span className="text-[8px] text-gray-400 font-bold uppercase tracking-wider leading-none mb-0.5">
                        {copied ? 'Copied!' : 'Click to copy'}
                    </span>
                    <span
                        className="text-[10px] font-bold text-amber-400 select-all hover:text-amber-300 transition-colors"
                        onClick={handleCopy}
                    >
                        {user.email || 'N/A'}
                    </span>
                </div>
            )}
        </div>
    );
};

export default UserInfo;
